document.addEventListener('DOMContentLoaded',function(){
(function(){
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveals */
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.12});
  document.querySelectorAll('.rv').forEach(el=>io.observe(el));

  /* burger */
  const burger=document.getElementById('burger');
  burger.addEventListener('click',()=>document.body.classList.toggle('menu-open'));
  document.querySelectorAll('.mmenu a').forEach(a=>a.addEventListener('click',()=>document.body.classList.remove('menu-open')));

  /* gallery */
  const mainImg=document.getElementById('mainImg');
  const thumbs=[...document.querySelectorAll('#pthumbs .pt')];
  const slides=thumbs.map(b=>b.dataset.src);
  let gi=0;
  function gShow(i){
    gi=(i+slides.length)%slides.length;
    mainImg.style.opacity=0;
    setTimeout(()=>{mainImg.src=slides[gi];mainImg.style.opacity=1;},150);
    thumbs.forEach((b,j)=>b.classList.toggle('on',j===gi));
    /* slide the thumbnail strip sideways only: scrollIntoView also scrolled the PAGE, so on a phone
       tapping a plan card threw the visitor ~440px back up to the photos, away from Add To Cart */
    const t=thumbs[gi],strip=t&&t.parentElement;
    if(t&&strip){const r=t.getBoundingClientRect(),sr=strip.getBoundingClientRect();strip.scrollBy({left:(r.left+r.width/2)-(sr.left+sr.width/2),behavior:'smooth'});}
  }
  thumbs.forEach((b,j)=>b.addEventListener('click',e=>{e.stopPropagation();gShow(j);}));
  document.getElementById('gprev').addEventListener('click',e=>{e.stopPropagation();gShow(gi-1);});
  document.getElementById('gnext').addEventListener('click',e=>{e.stopPropagation();gShow(gi+1);});
  addEventListener('keydown',e=>{
    if(document.getElementById('lb').classList.contains('on'))return;
    if(e.key==='ArrowLeft')gShow(gi-1);
    if(e.key==='ArrowRight')gShow(gi+1);
  });

  /* buy options */
  const atc=document.getElementById('atc'),barPrice=document.getElementById('barPrice');
  document.querySelectorAll('#buyopts .bopt').forEach(o=>{
    const pick=()=>{
      document.querySelectorAll('#buyopts .bopt').forEach(x=>x.classList.remove('on'));
      o.classList.add('on');
      atc.innerHTML=o.dataset.cta+'<span class="sheen"></span>';
      barPrice.innerHTML=o.dataset.price+' <small>KaiShine · '+(o.dataset.label||'One-Time')+'</small>';
      if(o.dataset.slide!==undefined)gShow(parseInt(o.dataset.slide,10));
      document.dispatchEvent(new CustomEvent('ks:plan'));
    };
    o.addEventListener('click',pick);
    o.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();pick();}});
  });


  /* express checkout: keep its variant in step with the chosen plan, and get out of the way
     when the refill subscription is ticked (express skips the cart, so it would drop it). */
  (function(){
    var box = document.getElementById('ksExpress');
    if (!box) return;
    var field = document.getElementById('ksExpressId');
    function sync(){
      var sel = document.querySelector('#buyopts .bopt.on');
      if (field && sel && sel.dataset.variant) field.value = sel.dataset.variant.trim();
      var cb = document.getElementById('subAdd');
      var row = cb && cb.closest('.subadd');
      /* a plan that carries a subscription line can't go through Buy-it-now (it buys one variant only) */
      box.hidden = box.hasAttribute('data-code-hidden') || !!(sel && sel.dataset.subPlan) || !!(cb && cb.checked && row && !row.hidden);
      var terms = document.getElementById('subTerms');
      if (terms) terms.hidden = !(sel && sel.dataset.subPlan);
    }
    document.addEventListener('ks:plan', function(){ setTimeout(sync, 30); });
    document.addEventListener('change', function(e){ if (e.target && e.target.id === 'subAdd') sync(); });
    sync();
  })();


  /* shareable discount link (/discount/CODE): show the saving on the page itself, not only at checkout.
     The KAI15 ad promises 15% off; without this the visitor saw $119.99 everywhere until the last step. */
  (function(){
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (m) return apply(decodeURIComponent(m[1]));
    /* Shopify deletes the cookie once a checkout starts and keeps the code on the cart: read it there */
    fetch('/cart.js', {credentials: 'same-origin'}).then(function(r){ return r.json(); }).then(function(c){
      var d = (c.discount_codes || [])[0]; if (d && d.code) apply(d.code);
    }).catch(function(){});
  function apply(raw){
    var code = String(raw).replace(/\+/g, ' ').trim().toUpperCase();
    if (!/^[A-Z0-9_-]{2,30}$/.test(code) || document.querySelector('.ks-codebar')) return;
    /* A code only rewrites prices when we know exactly what it takes off, because a page that
       promises less than checkout charges is worse than no promise at all.
         pct   - the percentage off
         only  - 'fountain' means the percentage applies to the fountain variant alone, so the
                 $19.99 refill subscription inside the One-Year price is left at full price. */
    var KNOWN = { KAI15: { pct: 15 }, FRESH30: { pct: 30, only: 'fountain' } };
    var rule = KNOWN[code] || {};
    var pct = rule.pct;
    var money = function(c){ return '$' + (c / 100).toFixed(2); };
    var cents = function(s){ var n = parseFloat(String(s).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : Math.round(n * 100); };
    var after = function(c){ return c - Math.floor(c * pct / 100); };   /* Shopify rounds the discount DOWN to the cent */
    var bar = document.createElement('div');
    bar.className = 'ks-codebar'; bar.setAttribute('role', 'status');
    bar.innerHTML = pct ? ('🍂 <b>' + code + '</b> applied: <b>' + pct + '% off</b> '
                          + (rule.only === 'fountain' ? 'the fountain' : 'your whole order') + ', taken off at checkout')
                        : ('<b>' + code + '</b> applied: your discount shows at checkout');
    document.body.insertBefore(bar, document.body.firstChild);
    document.documentElement.classList.add('has-codebar');
    /* the Buy-it-now wallet skips the cart; the cart is where the code is proven to apply, so send them there */
    var ex = document.getElementById('ksExpress');
    if (ex) { ex.setAttribute('data-code-hidden', '1'); ex.hidden = true; }
    if (!pct) return;
    function rewrite(fountainPrice){
    document.querySelectorAll('#buyopts .bopt').forEach(function(o){
      var c = cents(o.dataset.price); if (c == null) return;
      /* the part of this card's price the code actually touches */
      var hit = rule.only === 'fountain' ? (fountainPrice[o.dataset.variant] != null ? fountainPrice[o.dataset.variant] : c) : c;
      if (hit > c) hit = c;
      var now = money(c - (hit - after(hit))), was = money(c);
      o.dataset.price = now;
      o.dataset.cta = 'Add To Cart — ' + now;
      var p = o.querySelector('.bo-price');
      if (p) p.innerHTML = now + '<s>' + was + '</s>';
      if (!o.querySelector('.bo-code')) {
        var tag = document.createElement('span'); tag.className = 'bo-code'; tag.textContent = code + ' −' + pct + '%';
        o.appendChild(tag);                         /* a corner badge, like SAVE $20 — keeps the plan name full width */
      }
    });
    var on = document.querySelector('#buyopts .bopt.on');
    if (on) {
      var a = document.getElementById('atc'); if (a) a.innerHTML = on.dataset.cta + '<span class="sheen"></span>';
      var bp = document.getElementById('barPrice');
      if (bp) bp.innerHTML = on.dataset.price + ' <small>KaiShine · ' + (on.dataset.label || 'One-Time') + '</small>';
    }
    }
    if (rule.only !== 'fountain') return rewrite({});
    /* read the real variant prices so the page can never quote a number checkout disagrees with */
    fetch('/products/kaishine-wireless-cat-water-fountain.js', {credentials: 'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(p){ var map = {}; (p.variants || []).forEach(function(v){ map[String(v.id)] = v.price; }); rewrite(map); })
      .catch(function(){ /* no prices, no promise: the banner alone stays */ });
  }
  })();

  /* Meta ViewContent: these landing pages aren't Shopify product pages, so the Meta app never sends one.
     fbq arrives asynchronously through Shopify's web pixel, so wait for it (max ~10 s), send once. */
  (function(){
    var tries = 0;
    (function wait(){
      if (typeof window.fbq === 'function') {
        var on = document.querySelector('#buyopts .bopt.on');
        var price = on ? parseFloat(String(on.dataset.price).replace(/[^0-9.]/g, '')) : 119.99;
        try {
          window.fbq('track', 'ViewContent', { content_type: 'product', content_name: 'KaiShine Wireless Cat Water Fountain',
            content_ids: [on && on.dataset.variant ? on.dataset.variant.trim() : '43894430400602'], value: price, currency: 'USD' });
        } catch (e) {}
        return;
      }
      if (++tries < 20) setTimeout(wait, 500);
    })();
  })();

  /* live viewers */
  const liveN=document.getElementById('liveN');
  let n=27;

  /* lightbox */
  const lb=document.getElementById('lb'),lbImg=document.getElementById('lbImg'),lbVid=document.getElementById('lbVid'),lbCap=document.getElementById('lbCap');

  /* a real caption per photo: title + one line, looked up by file name, alt text as the fallback */
  var LB_CAPS = {
    'kaishine-hero-white'             : ["KaiShine Wireless Fountain", "304 food-grade stainless steel, a 3.2-liter tank and a faucet-style stream she can hear from the next room."],
    'kaishine-bundle-6filters-1100'   : ["The One-Year Plan", "The fountain plus six filters in one box, a full year of fresh water. Then 3 fresh filters every 6 months for $19.99; skip or cancel anytime."],
    'kaishine-bundle-12filters-1100'  : ["The Two-Year Plan", "The fountain plus twelve filters. Two years of clean water with nothing to reorder and nothing to remember."],
    'kaishine-sq7'                    : ["Four stages of filtration", "Non-woven fabric, activated carbon, ion-exchange resin and a foam pre-filter catch hair, dust and odors before every sip."],
    'kaishine-sq12'                   : ["Steel, not scratched plastic", "Plastic scratches, and grime settles into every scratch. Food-grade steel stays smooth, so slime has nothing to grip."],
    'kaishine-sq2'                    : ["45 days on one charge", "A 4200 mAh battery runs up to 45 days in sensor mode. No outlet to find, no cord for her to chew."],
    'kaishine-sq8'                    : ["It fits where she drinks", "7.9 × 10.2 × 5.1 inches, 3.2 liters — about a week of water for one cat, and the porthole shows the level at a glance."],
    'kaishine-sq9'                    : ["What is in the box", "The fountain, your filters, a USB-C charging cable and a quick-start guide. Two minutes from box to first sip."],
    'kaishine-sq10'                   : ["Three ways to flow", "Sensor mode starts the stream when she walks up. Prefer a steady flow? Switch to timed or continuous."],
    'kaishine-sq1'                    : ["Does your cat need KaiShine?", "Sleeping more, a duller coat, small hard litter clumps, a dry-food diet — the quiet signs of a cat who is not drinking enough."],
    'kaishine-sq1k'                   : ["Signs she is not drinking enough", "Sleeping more, a duller coat, small hard litter clumps — the quiet signs owners usually put down to age."],
    'kaishine-sq3'                    : ["The science of thirst", "Cats evolved eating prey that was about 70% water, so their thirst drive is weak. A still bowl rarely tempts them."],
    'kaishine-sq4'                    : ["How to use it", "Fill it, put it where she likes to drink, and let the motion sensor do the rest. No app, no account, no plumbing."],
    'kaishine-sq4k'                   : ["How to use it", "Fill it, put it where she likes to drink, and let the motion sensor do the rest. No app, no account, no plumbing."],
    'kaishine-sq5'                    : ["Better days for her, and for you", "Fresh water on tap, no more faucet begging, and one less thing to think about every morning."],
    'kaishine-sq6'                    : ["What KaiShine puts an end to", "Faucet begging, glasses knocked off the counter, and a bowl she walks past all day without touching."],
    'kaishine-ugc10'                  : ["Two cats, one fountain", "The 3.2-liter tank and the gentle stream are easy to share, so one KaiShine covers a two-cat home."],
    'kaishine-science-cat'            : ["Water she will actually use", "Moving, filtered water works with her instincts instead of against them — so drinking becomes a habit, not an event."],
    'kaishine-feat-steel'             : ["Nowhere for slime to hide", "304 food-grade steel stays smooth, so a quick rinse gets it properly clean."],
    'kaishine-feat-filter'            : ["Fresh with every sip", "A three-layer cartridge plus a foam pre-filter. Swap it in ten seconds, about every two months."],
    'kaishine-feat-cordless'          : ["Put it where she drinks", "No outlet to find and no cord to chew — up to 45 days of flow on a single charge."],
    'kaishine-feat-quiet'             : ["She will not even notice it", "Under 40 dB, about as quiet as a library. Calm enough for nervous cats, and for the bedroom at night."],
    'kaishine-feat-tank'              : ["Refill about once a week", "3.2 liters covers most single-cat homes for a week, and the round window shows the level at a glance."],
    'kaishine-feat-sensor'            : ["Flows when she walks up", "The sensor starts the stream within about three feet and stops it when she leaves, which saves battery."],
    'kaishine-ch1-steel'              : ["Cool, clean, moving water", "Filtered water in constant motion stays cool and appealing all day, instead of going flat by lunchtime."],
    'kaishine-ch2-corner'             : ["At home in any corner", "Because there is no cord, the fountain goes where she likes to drink rather than where the outlet is."],
    'kaishine-dirty-bowl'             : ["Her old bowl", "Still water grows a bacterial film within hours — the slime she licks with every single drink."],
    'kaishine-clean-water'            : ["The same corner, with KaiShine", "Filtered water, always moving, in a steel basin that gives that film nothing to hold on to."]
  };

  function lbCaption(src,alt){
    var key=String(src).split('?')[0].split('/').pop().replace(/\.(webp|jpg|jpeg|png|mp4)$/i,'').replace(/_\d+x\d*$/,'');
    var esc=function(t){return String(t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');};
    var c=LB_CAPS[key];
    if(c)return '<span class="lb-cap-t">'+esc(c[0])+'</span><span class="lb-cap-d">'+esc(c[1])+'</span>';
    if(alt)return '<span class="lb-cap-t">'+esc(alt)+'</span>';
    return '';
  }
  function lbOpen(src,isVid,cap){
    lbImg.style.display=isVid?'none':'block';
    lbVid.style.display=isVid?'block':'none';
    if(isVid){lbVid.src=src;lbVid.muted=false;lbVid.play().catch(()=>{});}else{lbImg.src=src;lbVid.pause();}
    lbCap.innerHTML=lbCaption(src,cap);lb.classList.add('on');
  }
  function lbClose(){lb.classList.remove('on');lbVid.pause();lbVid.removeAttribute('src');}
  if(lbImg) lbImg.addEventListener('click',e=>{e.stopPropagation();lbClose();});   /* tapping the enlarged photo closes it */
  document.querySelectorAll('[data-view]').forEach(el=>{
    el.addEventListener('click',e=>{
      if(e.target.closest('a,button')||!e.target.closest('img,video'))return;
      const vid=el.querySelector('video'),img=el.querySelector('img');
      if(vid){lbOpen(vid.currentSrc||vid.src,true,'');}
      else if(img){lbOpen(img.currentSrc||img.src,false,img.alt||'');}
    });
  });
  document.getElementById('lbX').addEventListener('click',lbClose);
  lb.addEventListener('click',e=>{if(e.target===lb)lbClose();});
  addEventListener('keydown',e=>{if(e.key==='Escape'&&lb.classList.contains('on'))lbClose();});

  /* videos: play only when visible; hide broken video -> poster img fallback */
  document.querySelectorAll('video[autoplay]').forEach(v=>{
    new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){v.play().catch(()=>{});}else{v.pause();}}),{threshold:.15}).observe(v);
    v.addEventListener('error',()=>{
      const img=document.createElement('img');img.src=v.poster;v.replaceWith(img);
    },true);
  });

  /* thumbnail strip arrows */
  const pth=document.getElementById('pthumbs');
  const tP=document.getElementById('tPrev'),tN=document.getElementById('tNext');
  if(tP&&pth){tP.addEventListener('click',e=>{e.stopPropagation();pth.scrollBy({left:-190,behavior:'smooth'});});}
  if(tN&&pth){tN.addEventListener('click',e=>{e.stopPropagation();pth.scrollBy({left:190,behavior:'smooth'});});}

  /* video strip: drag + live progress bar */
  const vs=document.getElementById('vslider'),vsBar=document.getElementById('vsBar');
  if(vs&&vsBar){
    const syncBar=()=>{
      const max=vs.scrollWidth-vs.clientWidth;
      const frac=vs.clientWidth/vs.scrollWidth;
      vsBar.style.width=Math.max(12,frac*100)+'%';
      const travel=vs.clientWidth*(1-frac);
      vsBar.style.transform='translateX('+(max>0?(vs.scrollLeft/max)*travel:0)+'px)';
    };
    vs.addEventListener('scroll',syncBar,{passive:true});
    addEventListener('resize',syncBar);
    setTimeout(syncBar,200);syncBar();
    let vdn=false,vsx=0,vsl=0;
    vs.addEventListener('pointerdown',e=>{vdn=true;vsx=e.clientX;vsl=vs.scrollLeft;vs.classList.add('drag');vs.setPointerCapture(e.pointerId);});
    vs.addEventListener('pointermove',e=>{if(vdn){vs.scrollLeft=vsl-(e.clientX-vsx);syncBar();}});
    ['pointerup','pointercancel'].forEach(ev=>vs.addEventListener(ev,()=>{vdn=false;vs.classList.remove('drag');}));
  }

  /* buy-box mini review carousel: swipe + dots + arrows */
  const mrT=document.getElementById('mrTrack'),mrD=document.getElementById('mrDots');
  if(mrT&&mrD){
    const mrGo=d=>mrT.scrollTo({left:(Math.round(mrT.scrollLeft/mrT.clientWidth)+d)*mrT.clientWidth,behavior:'smooth'});
    document.getElementById('mrPrev').addEventListener('click',()=>mrGo(-1));
    document.getElementById('mrNext').addEventListener('click',()=>mrGo(1));
    const dots=[...mrD.children];
    const setDot=i=>dots.forEach((d,j)=>d.classList.toggle('on',j===i));
    mrT.addEventListener('scroll',()=>{
      const i=Math.round(mrT.scrollLeft/mrT.clientWidth);
      setDot(Math.max(0,Math.min(dots.length-1,i)));
    },{passive:true});
    dots.forEach((d,i)=>d.addEventListener('click',()=>mrT.scrollTo({left:i*mrT.clientWidth,behavior:'smooth'})));
    let mdn=false,msx=0,msl=0;
    mrT.addEventListener('pointerdown',e=>{mdn=true;msx=e.clientX;msl=mrT.scrollLeft;mrT.setPointerCapture(e.pointerId);});
    mrT.addEventListener('pointermove',e=>{if(mdn)mrT.scrollLeft=msl-(e.clientX-msx);});
    ['pointerup','pointercancel'].forEach(ev=>mrT.addEventListener(ev,()=>{mdn=false;
      mrT.scrollTo({left:Math.round(mrT.scrollLeft/mrT.clientWidth)*mrT.clientWidth,behavior:'smooth'});}));
  }

  /* science rings: fill + count up each time they scroll into view (one after another) */
  window.KS_RINGS=true;
  const ringsReduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ringRun=(ring)=>{
    const span=ring.querySelector('.rnum');
    ring.classList.add('go');
    if(!span)return;
    const target=parseInt(span.dataset.t,10);
    if(ringsReduced){span.textContent=target+'%';return;}
    const t0=performance.now(),dur=1100;
    (function step(now){if(ring.dataset.run!=='1')return;/* a frame queued before the ring left view must not repaint a half-count */const k=Math.min(1,(now-t0)/dur),ease=1-Math.pow(1-k,3);span.textContent=Math.round(target*ease)+'%';if(k<1)requestAnimationFrame(step);})(t0);
  };
  /* start as soon as the ring is properly on screen, and when it leaves mid-count leave the
     REAL number behind — a fast scroller must never be left looking at 0% or a half-count. */
  const ringIO=new IntersectionObserver(es=>es.forEach(e=>{
    const ring=e.target;
    const span=ring.querySelector('.rnum');
    if(e.isIntersecting&&e.intersectionRatio>=.2&&ring.dataset.run!=='1'){
      ring.dataset.run='1';
      if(span&&ring.dataset.seen==='1')span.textContent='0%';
      setTimeout(()=>{if(ring.dataset.run==='1')ringRun(ring);},(+ring.dataset.i||0)*140);
    }else if(!e.isIntersecting&&ring.dataset.run==='1'){
      ring.dataset.run='';ring.dataset.seen='1';
      if(span)span.textContent=(parseInt(span.dataset.t,10)||0)+'%';
    }
  }),{threshold:[0,.2,.45]});
  document.querySelectorAll('.ring').forEach((r,i)=>{r.dataset.i=i;ringIO.observe(r);});

  /* benefits drop line: follows viewport centre */
  const benwrap=document.getElementById('benwrap'),blit=document.getElementById('blit'),bdrop=document.getElementById('bdrop');
  if(benwrap&&matchMedia('(min-width:900px)').matches&&!reduced){
    let bTop=0,bH=1;const nodes=[];
    const measure=()=>{
      const r=benwrap.getBoundingClientRect();
      bTop=r.top+scrollY+30;bH=Math.max(1,benwrap.offsetHeight-60);
      benwrap.querySelectorAll('.bnode').forEach(n=>n.remove());nodes.length=0;
      benwrap.querySelectorAll('.ben').forEach(b=>{
        const br=b.getBoundingClientRect();
        const ratio=Math.min(1,Math.max(0,((br.top+scrollY+br.height/2)-bTop)/bH));
        const el=document.createElement('div');el.className='bnode';
        el.style.top=(30+ratio*bH)+'px';el.dataset.ratio=ratio;
        benwrap.appendChild(el);nodes.push(el);
      });
    };
    let lastP=-1;
    const update=()=>{
      const p=Math.min(1,Math.max(0,(scrollY+innerHeight*.5-bTop)/bH));
      if(Math.abs(p-lastP)<0.0005)return;
      lastP=p;
      blit.style.height=(p*100)+'%';
      bdrop.style.top=(30+p*bH)+'px';
      bdrop.style.opacity=p>0.003&&p<0.997?1:0;
      nodes.forEach(n=>n.classList.toggle('on',p>=parseFloat(n.dataset.ratio)));
    };
    measure();update();
    (function bloop(){update();requestAnimationFrame(bloop)})();
    addEventListener('resize',()=>{measure();lastP=-1;update();});
    addEventListener('load',()=>{measure();lastP=-1;update();});
    setTimeout(()=>{measure();lastP=-1;update();},1500);
  }

  /* buybar: appears as soon as the main Add To Cart has scrolled off the top */
  const atcEl=document.getElementById('atc'),bar=document.getElementById('buybar');
  /* phones: show the bar from the first screen (price + "Choose Your Plan" -> plan cards), because 3 in 4 phone
     visitors never scroll to Add To Cart. Past Add To Cart it is the normal Add To Cart bar. */
  const phone=matchMedia('(max-width:820px)');
  const barBtn=bar?bar.querySelector('.btn'):null;
  const setBar=mode=>{
    if(!bar) return;
    if(mode==='hide'){bar.style.display='none';return;}
    bar.style.display='';bar.dataset.mode=mode;
    if(barBtn){barBtn.textContent=mode==='preview'?'Choose Your Plan':'Add To Cart';barBtn.setAttribute('href',mode==='preview'?'#buyopts':'#top');}
  };
  /* once the visitor has tapped a plan (or been taken to the cards), the phone bar is a real Add To Cart:
     before, it kept saying "Choose Your Plan" and only scrolled back to the cards it was already showing */
  let atcAt='below',planSeen=false;
  const renderBar=()=>setBar(atcAt==='in'?'hide':atcAt==='above'?'add':(phone.matches?(planSeen?'add':'preview'):'hide'));
  const seePlan=()=>{if(!planSeen){planSeen=true;renderBar();}};
  document.addEventListener('ks:plan',seePlan);
  document.addEventListener('ks:plans-shown',seePlan);
  if(atcEl&&bar) new IntersectionObserver(es=>es.forEach(e=>{
    atcAt=e.isIntersecting?'in':(e.boundingClientRect.top>0?'below':'above');
    renderBar();
  }),{threshold:0}).observe(atcEl);

  /* cursor */
  const paw=document.querySelector('.cursor-paw'),ringC=document.querySelector('.cursor-ring');
  if(matchMedia('(hover:hover)').matches && !reduced){
    let rx=-100,ry=-100,tx=-100,ty=-100,live=false;
    addEventListener('mousemove',e=>{
      if(!live){live=true;rx=e.clientX;ry=e.clientY;document.body.classList.add('cursor-on');}
      tx=e.clientX;ty=e.clientY;
      paw.style.left=tx+'px';paw.style.top=ty+'px';
    });
    (function loop(){rx+=(tx-rx)*.16;ry+=(ty-ry)*.16;ringC.style.left=rx+'px';ringC.style.top=ry+'px';requestAnimationFrame(loop)})();
    addEventListener('mousedown',()=>document.body.classList.add('cursor-down'));
    addEventListener('mouseup',()=>document.body.classList.remove('cursor-down'));
    document.querySelectorAll('[data-hover],a,button,summary,[data-view],.bopt').forEach(el=>{
      el.addEventListener('mouseenter',()=>document.body.classList.add('cursor-hover'));
      el.addEventListener('mouseleave',()=>document.body.classList.remove('cursor-hover'));
    });
    addEventListener('click',e=>{
      const r=document.createElement('div');r.className='ripple';
      r.style.left=e.clientX+'px';r.style.top=e.clientY+'px';
      document.body.appendChild(r);setTimeout(()=>r.remove(),600);
    });
  }
})();

/* ---- casual content protection (deters right-click / drag / devtools shortcuts) ---- */
(function(){
  const block=e=>{e.preventDefault();return false;};
  document.addEventListener('contextmenu',e=>{if(e.target.closest('img,video'))block(e);});
  document.addEventListener('dragstart',e=>{if(e.target.closest('img,video'))block(e);});
  document.addEventListener('keydown',e=>{
    const k=(e.key||'').toUpperCase();
    if(k==='F12') return block(e);
    if((e.ctrlKey||e.metaKey)&&e.shiftKey&&['I','J','C'].includes(k)) return block(e);
    if((e.ctrlKey||e.metaKey)&&['U','S'].includes(k)) return block(e);
  });
})();
/* ---- KaiShine cart drawer: add on site, review, then checkout ---- */
(function(){
  var SYM = {USD:"$", EUR:"€", GBP:"£", CAD:"CA$", AUD:"A$"};
  function cur(){ try { return Shopify.currency.active; } catch(e){ return ""; } }
  function fmt(c){ var s = SYM[cur()] || (cur() ? cur() + " " : ""); return s + (c/100).toFixed(2); }
  var imgByVariant = {};
  function galleryImg(){ var m = document.getElementById("mainImg"); return m ? m.getAttribute("src") : ""; }
  function variantOf(){
    var s = document.querySelector("#buyopts .bopt.on");
    return s && s.dataset.variant ? s.dataset.variant.trim() : "";
  }
  function ico(d){
    return '<svg viewBox="0 0 24 24" fill="none" width="15" height="15" aria-hidden="true">' +
           '<path d="' + d + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  var I_CHECK  = "M20 6L9 17l-5-5";
  var I_TRUCK  = "M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 100-4 2 2 0 000 4zM18 19a2 2 0 100-4 2 2 0 000 4z";
  var I_SHIELD = "M12 3l7 3v6c0 4-3 7-7 8-4-1-7-4-7-8V6z";
  var I_LOCK   = "M6 11V8a6 6 0 1112 0v3M5 11h14v9H5z";

  var root = document.createElement("div");
  root.className = "ks-cart";
  root.setAttribute("hidden","");
  root.innerHTML =
    '<div class="ks-ov" data-close></div>' +
    '<aside class="ks-panel" role="dialog" aria-modal="true" aria-label="Your cart">' +
      '<header class="ks-head">' +
        '<h3>Your cart <span class="ks-count">0</span></h3>' +
        '<button class="ks-x" data-close data-hover aria-label="Close cart">' +
          '<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</header>' +
      '<div class="ks-ship">' + ico(I_TRUCK) + '<b>Free US shipping</b> included on this order</div>' +
      '<div class="ks-body" aria-live="polite"></div>' +
      '<footer class="ks-foot">' +
        '<div class="ks-sum">' +
          '<div class="ks-row"><span>Subtotal</span><b class="ks-total">&mdash;</b></div>' +
          '<div class="ks-discs"></div>' +
          '<div class="ks-row"><span>Shipping</span><b class="ks-free">Free</b></div>' +
          '<div class="ks-row ks-grand"><span>Total</span><b class="ks-gt">&mdash;</b></div>' +
        '</div>' +
        '<p class="ks-note">Taxes calculated at checkout.</p>' +
        '<a class="ks-go" href="/checkout" data-hover>' + ico(I_LOCK) + '<span>Confirm &amp; Checkout</span></a>' +
        '<div class="ks-express-slot"></div>' +
        '<button class="ks-cont" data-close data-hover type="button">Keep shopping</button>' +
        '<ul class="ks-trust">' +
          '<li>' + ico(I_SHIELD) + '30-day guarantee</li>' +
          '<li>' + ico(I_TRUCK)  + 'Free US shipping</li>' +
          '<li>' + ico(I_CHECK)  + '12-month warranty</li>' +
        '</ul>' +
        '<div class="ks-pay"><span class="ks-pay-t">' + ico(I_LOCK) + 'Guaranteed safe &amp; secure checkout</span><div class="ks-pay-b"></div></div>' +
      '</footer>' +
    '</aside>';
  document.body.appendChild(root);
  /* adopt the server-rendered wallet buttons into the drawer (once) */
  try {
    var parked = document.getElementById("ksDrawerExpress");
    var slot = root.querySelector(".ks-express-slot");
    if (parked && slot) { parked.hidden = false; slot.appendChild(parked); }
  } catch (e) { /* drawer still works without them */ }


  /* reuse the payment badges already on the page so they never drift apart */
  var src = document.querySelector(".paybadges");
  var slot = root.querySelector(".ks-pay-b");
  if (src && slot) slot.appendChild(src.cloneNode(true));
  else if (slot) slot.parentNode.style.display = "none";

  var body  = root.querySelector(".ks-body");
  var foot  = root.querySelector(".ks-foot");
  var ship  = root.querySelector(".ks-ship");
  var lastFocus = null;

  function open(){
    lastFocus = document.activeElement;
    root.removeAttribute("hidden");
    void root.offsetWidth;                 // force reflow so the transition runs (rAF can be throttled)
    root.classList.add("on");
    document.documentElement.style.overflow = "hidden";
    var b = root.querySelector(".ks-x"); if (b) b.focus();
  }
  function close(){
    root.classList.remove("on");
    document.documentElement.style.overflow = "";
    setTimeout(function(){ root.setAttribute("hidden",""); }, 340);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.addEventListener("click", function(e){
    if (e.target.closest("[data-close]")) close();
    if (e.target.closest(".ks-shop")) { close(); location.hash = "#top"; }
  });
  addEventListener("keydown", function(e){ if (e.key === "Escape" && !root.hasAttribute("hidden")) close(); });

  function render(cart){
    root.querySelector(".ks-count").textContent = cart.item_count;
    document.dispatchEvent(new CustomEvent("ks:cart", {detail:{count: cart.item_count}}));
    if (!cart.items.length){
      body.innerHTML =
        '<div class="ks-empty">' +
          '<div class="ks-empty-i">' +
            '<svg viewBox="0 0 24 24" fill="none" width="26" height="26"><path d="M6 6h15l-1.5 9h-12zM6 6L5 3H2M9 20a1 1 0 100-2 1 1 0 000 2zM18 20a1 1 0 100-2 1 1 0 000 2z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</div>' +
          '<p>Your cart is empty.</p>' +
          '<button type="button" class="ks-shop" data-hover>Shop the fountain</button>' +
        '</div>';
      foot.classList.add("ks-hide"); ship.classList.add("ks-hide");
      return;
    }
    foot.classList.remove("ks-hide"); ship.classList.remove("ks-hide");
    /* phones show only a sliver of the list: put the fountain above the refill subscription
       so the first thing a customer sees is what they actually chose. Keep the original
       line index for the quantity and remove buttons. */
    var ksOrder = cart.items.map(function(i, n){ return {i: i, n: n}; });
    ksOrder.sort(function(a, b){
      return (a.i.selling_plan_allocation ? 1 : 0) - (b.i.selling_plan_allocation ? 1 : 0);
    });
    body.innerHTML = ksOrder.map(function(o){
      var i = o.i, n = o.n;
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, "_180x$1$2")
                        : (imgByVariant[i.variant_id] || galleryImg());
      return '<div class="ks-item">' +
        (img ? '<img src="' + img + '" alt="" width="72" height="72" loading="lazy">'
             : '<div class="ks-noimg">' + ico(I_CHECK) + '</div>') +
        '<div class="ks-meta">' +
          '<div class="ks-t">' + i.product_title + '</div>' +
          (i.variant_title ? '<span class="ks-v">' + i.variant_title + '</span>' : '') +
          (i.selling_plan_allocation ?
            '<span class="ks-v ks-sub">' + i.selling_plan_allocation.selling_plan.name + '</span>' +
            '<div class="ks-subnote">Renews automatically at ' + fmt(i.selling_plan_allocation.price) + ' &middot; skip or cancel anytime</div>' : '') +
          '<div class="ks-qty">' +
            '<button type="button" data-hover data-line="' + (n+1) + '" data-q="' + (i.quantity-1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button type="button" data-hover data-line="' + (n+1) + '" data-q="' + (i.quantity+1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="ks-right">' +
          '<div class="ks-p">' + ((i.original_line_price || 0) > (i.final_line_price != null ? i.final_line_price : i.line_price)
            ? '<s class="ks-was">' + fmt(i.original_line_price) + '</s> ' : '') + fmt(i.final_line_price != null ? i.final_line_price : i.line_price) + '</div>' +
          '<button type="button" class="ks-rm" data-hover data-line="' + (n+1) + '" data-q="0">Remove</button>' +
        '</div>' +
      '</div>';
    }).join("");
    /* discount codes live on the cart: show them as their own line so $119.99 -> $102.00 is explained */
    var discs = (cart.cart_level_discount_applications || []).filter(function(d){ return d && d.total_allocated_amount > 0; });
    var dbox = root.querySelector(".ks-discs");
    if (dbox) dbox.innerHTML = discs.map(function(d){
      var name = String(d.title || 'Discount').replace(/[<>&"]/g, '');
      var pc = d.value_type === 'percentage' ? ' (' + parseFloat(d.value) + '% off)' : '';
      return '<div class="ks-row ks-disc"><span>' + name + pc + '</span><b>&minus;' + fmt(d.total_allocated_amount) + '</b></div>';
    }).join("");
    root.querySelector(".ks-total").textContent = fmt(discs.length && cart.original_total_price ? cart.original_total_price : cart.total_price);
    root.querySelector(".ks-gt").textContent    = fmt(cart.total_price);
  }

  function refresh(){
    return fetch("/cart.js", {cache:"no-store", credentials:"same-origin"})
      .then(function(r){ return r.json(); }).then(render);
  }
  window.KSCart = { open: function(){ refresh().then(open, function(){ location.href = "/cart"; }); } };

  body.addEventListener("click", function(e){
    var b = e.target.closest("button[data-line]");
    if (!b) return;
    body.classList.add("ks-busy");
    fetch("/cart/change.js", {
      method:"POST", credentials:"same-origin",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({line: +b.dataset.line, quantity: +b.dataset.q})
    }).then(function(r){ return r.json(); })
      .then(render)
      .catch(function(){ return refresh(); })
      .then(function(){ body.classList.remove("ks-busy"); });
  });

  /* The refill subscription rides along with the fountain when the shopper has
     ticked it. Separate line item with its own selling_plan -- that is what makes
     Shopify create a real subscription contract. Never added unticked.        */
  /* The add-on only makes sense on the One-Time Purchase, which ships a single
     cartridge (~2 months). The One-Year plan already includes 6 filters and the
     Two-Year 12 -- starting a 6-monthly refill alongside those would mail people
     filters they already have and bill them for it. So the row is shown only for
     One-Time, and is force-unchecked whenever it is hidden so it can never be
     added invisibly.                                                          */
  function syncRefillRow(){
    var row = document.querySelector(".subadd");
    if (!row) return;
    var sel = document.querySelector("#buyopts .bopt.on");
    var isOneTime = sel && /One-Time/i.test(sel.dataset.label || "");
    row.hidden = !isOneTime;
    if (!isOneTime){
      var cb = document.getElementById("subAdd");
      if (cb) cb.checked = false;
    }
  }
  document.addEventListener("click", function(e){
    if (e.target.closest && e.target.closest("#buyopts .bopt")) setTimeout(syncRefillRow, 30);
  });
  syncRefillRow();
  document.addEventListener("ks:plan", function(){ setTimeout(syncRefillRow, 30); });

  function refillItem(){
    var cb = document.getElementById("subAdd");
    if (!cb || !cb.checked) return null;
    var row = cb.closest(".subadd");
    if (row && row.hidden) return null;          /* belt and braces */
    var v = Number(cb.dataset.variant), p = Number(cb.dataset.plan);
    if (!v || !p) return null;
    return { id: v, quantity: 1, selling_plan: p };
  }

  var busy = false;
  function addNote(msg){
    var host = document.getElementById("atc"), el = document.getElementById("ksAddErr");
    if (!el){ el = document.createElement("p"); el.id = "ksAddErr"; el.className = "ks-adderr"; el.setAttribute("role", "alert"); }
    if (host && host.parentNode && el.parentNode !== host.parentNode) host.parentNode.insertBefore(el, host.nextSibling);
    el.textContent = msg; el.hidden = !msg;
  }
  function add(e){
    /* the sticky bar in preview mode only scrolls to the plan cards */
    var host = e.currentTarget && e.currentTarget.closest ? e.currentTarget.closest('#buybar') : null;
    if (host && host.dataset.mode === 'preview') {
      e.preventDefault();
      var t = document.getElementById('buyopts'); if (t) t.scrollIntoView({behavior:'smooth', block:'start'});
      document.dispatchEvent(new CustomEvent('ks:plans-shown'));
      return;
    }
    var id = variantOf();
    if (!id) return;                        // no variant wired: leave the link alone
    e.preventDefault();
    if (busy) return;                       // a second tap while adding must not add a second fountain
    busy = true;
    var btn = e.currentTarget, label = btn.innerHTML;
    imgByVariant[Number(id)] = galleryImg();
    btn.classList.add("ks-loading"); btn.setAttribute("aria-busy", "true"); btn.textContent = "Adding\u2026";
    addNote("");
    var items = [{id: Number(id), quantity: 1}];
    /* the One-Year Plan = its variant + the refill 3-pack on its 6-monthly plan, always together */
    var planCard = document.querySelector("#buyopts .bopt.on");
    if (planCard && planCard.dataset.subPlan && planCard.dataset.subVariant)
      items.push({id: Number(planCard.dataset.subVariant), quantity: 1, selling_plan: Number(planCard.dataset.subPlan)});
    var refill = refillItem();
    if (refill) items.push(refill);
    fetch("/cart/add.js", {
      method:"POST", credentials:"same-origin",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify({items: items})
    }).then(function(r){
      if (!r.ok) throw new Error("add failed");
      /* the add worked; if only the re-read fails, show the cart page instead of an error */
      return refresh().then(function(){ return true; }, function(){ location.href = "/cart"; return false; });
    }).then(function(ok){ if (ok) open(); })
      .catch(function(){ addNote("Sorry, that didn\u2019t go through. Please tap Add To Cart again."); })
      .then(function(){
        busy = false;
        btn.classList.remove("ks-loading"); btn.removeAttribute("aria-busy");
        var on = document.querySelector("#buyopts .bopt.on");
        btn.innerHTML = (btn.id === "atc" && on && on.dataset.cta) ? on.dataset.cta + '<span class="sheen"></span>' : label;
      });
  }

  var atc = document.getElementById("atc");
  if (atc) atc.addEventListener("click", add);
  document.querySelectorAll(".buybar .btn").forEach(function(b){ b.addEventListener("click", add); });
})();

});
